export default {"src":"/_next/static/media/solar_buildings-linear3.b36da7a7.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};